import React from 'react';
import { SkillConfig } from '../../types/onboarding';
import { Image } from '../../../ui/Image';
import { Button } from '../../components';

import { useTranslation } from 'react-i18next';

interface AwseyeSkillSetupProps {
  skill: SkillConfig;
  onComplete: () => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

export const AwseyeSkillSetup: React.FC<AwseyeSkillSetupProps> = ({
  skill,
  onCancel,
}) => {
  const { t } = useTranslation('pleri/onboarding');
  return (
    <div className="mx-auto max-w-2xl">
      {/* 1. Title */}
      <div className="mb-8 text-center">
        <h2 className="text-2xl leading-tight font-semibold text-gray-900 dark:text-gray-100">
          {t('awseye')}
        </h2>
      </div>
      <div className="rounded-lg bg-white p-6 dark:bg-gray-900">
        {/* 2. Logo */}
        <div className="mb-8 text-center">
          <div className="relative mx-auto inline-block">
            <div className="absolute inset-0 animate-[pulse_4s_ease-in-out_infinite] rounded-xl bg-blue-50 blur-xl dark:bg-blue-950/10" />
            {skill.image ? (
              skill.image.src ? (
                <Image
                  src={skill.image.src}
                  alt={skill.image.alt}
                  className="relative h-20 rounded-xl object-cover"
                />
              ) : (
                <Image
                  name={skill.image.name}
                  type={skill.image.type}
                  className="relative h-20 rounded-xl object-cover"
                  fileExtension={skill.image.fileExtension}
                />
              )
            ) : (
              <div className="relative flex h-20 w-20 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500/20 to-indigo-600/20">
                <span className="text-4xl leading-tight">{skill.icon}</span>
              </div>
            )}
          </div>
        </div>

        {/* 3. Short Description */}
        <div className="mb-8 text-center">
          <p className="text-gray-600 dark:text-gray-400">
            {t('iTrackAndAnalyzePubliclyAccessibleAws')}
          </p>
        </div>

        {/* 4. Learn More Link - Optional section */}
        <div className="mb-8 text-center">
          <p className="text-sm text-gray-500">
            {t('iAutomaticallySetUpThisToolFor')}
          </p>
        </div>

        {/* 6. Call to Action Button */}
        <div className="mb-6 flex flex-col items-center">
          <Button onClick={onCancel} variant="secondary" className="px-8 py-3">
            {t('goBack')}
          </Button>
        </div>
      </div>
    </div>
  );
};
